import React from "react";
import ClassNames from "classnames";
import Link from "gatsby-link";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    };
    this.imageHasLoaded = this.imageHasLoaded.bind(this);
  }

  componentDidMount() {
    /*this.theImage = new Image();
    this.theImage.onload = this.imageHasLoaded;
    this.theImage.src = this.props.src;*/
  }

  imageHasLoaded() {
    TweenMax.to(this.img, 0.4, { opacity: 1, ease: Expo.easeOut });
  }

  render() {
    return (
      <div className="Footer">
        <div className="column">
          <div className="logo">
             <img src="/images/yf-logo-small-white.png" alt="logo" />
          </div>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/weekdaywarriors/"
              target="_blank"
              className="social"
            >
              <svg
                width="18"
                height="18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.621 0H5.38C3.926 0 2.678.504 1.635 1.512.592 2.52.047 3.75 0 5.203v7.594c.047 1.453.592 2.683 1.635 3.691C2.678 17.496 3.925 18 5.379 18h7.277c1.453 0 2.707-.527 3.762-1.582C17.473 15.363 18 14.098 18 12.621V5.38c0-1.477-.527-2.742-1.582-3.797C15.363.527 14.098 0 12.621 0zm3.586 12.621c0 .984-.352 1.822-1.055 2.514-.703.691-1.535 1.037-2.496 1.037H5.38a3.395 3.395 0 0 1-2.514-1.055c-.691-.703-1.037-1.535-1.037-2.496V5.38c0-.984.352-1.822 1.055-2.514.703-.691 1.535-1.037 2.496-1.037h7.277c.985 0 1.822.352 2.514 1.055.691.703 1.037 1.535 1.037 2.496v7.242zm-3.797-6.75C11.52 4.957 10.43 4.5 9.14 4.5c-1.288 0-2.384.451-3.286 1.354C4.95 6.756 4.5 7.852 4.5 9.14s.451 2.384 1.354 3.287c.902.902 1.998 1.353 3.287 1.353s2.384-.45 3.287-1.353c.902-.903 1.353-1.998 1.353-3.287 0-1.29-.457-2.38-1.37-3.27zm-1.265 5.309c-.54.539-1.207.808-2.004.808-.797 0-1.471-.275-2.022-.826-.55-.55-.826-1.225-.826-2.021 0-.797.275-1.471.826-2.022.55-.55 1.225-.826 2.022-.826.796 0 1.47.275 2.021.826.55.55.826 1.225.826 2.022 0 .796-.281 1.476-.843 2.039zm2.882-7.77a.866.866 0 0 0-.668-.316c-.257 0-.486.1-.685.299-.2.199-.299.427-.299.685 0 .258.1.486.299.686.199.199.428.298.685.298.258 0 .487-.1.686-.298.2-.2.299-.428.299-.686a.866.866 0 0 0-.317-.668z"
                  fill="#fff"
                />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/weekdaywarriorsnyc/"
              target="_blank"
              className="social"
            >
              <svg
                width="18"
                height="18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.36 2.616C17.12 4.376 18 6.504 18 9c0 2.48-.88 4.6-2.64 6.36C13.6 17.12 11.48 18 9 18c-2.496 0-4.624-.88-6.384-2.64C.872 13.616 0 11.496 0 9c0-2.512.872-4.64 2.616-6.384C4.344.872 6.472 0 9 0c2.496 0 4.616.872 6.36 2.616zM7.992 7.824c0-.784.248-1.452.744-2.004s1.12-.828 1.872-.828H12v2.016h-1.392c-.16 0-.3.06-.42.18s-.18.26-.18.42V9H12v1.992h-1.992v4.944c1.488-.192 2.8-.856 3.936-1.992C15.32 12.568 16.008 10.92 16.008 9c0-1.952-.688-3.608-2.064-4.968-1.376-1.36-3.024-2.04-4.944-2.04-1.952 0-3.608.68-4.968 2.04-1.36 1.36-2.04 3.016-2.04 4.968 0 1.92.68 3.568 2.04 4.944 1.136 1.136 2.456 1.8 3.96 1.992v-4.944H6V9h1.992V7.824z"
                  fill="#fff"
                />
              </svg>
            </a>
          </div>
        </div>

        <ul className="column">
          <li>
            <Link to="/buy">shop</Link>
          </li>
          <li>
            <Link to="/faqs">faq</Link>
          </li>
          <li>
            <a href="mailto:hello@weekdaywarriors.com">contact</a>
          </li>
        </ul>
        <ul className="column light">
          <li>
            <Link to="/terms">terms & conditions</Link>
          </li>
          <li>
            <Link to="/returns">returns & exchanges</Link>
          </li>
          <li>
            <Link to="/privacy">privacy policy</Link>
          </li>
        </ul>

        <div className="column">
          <div className="disclaimer-notice">
            <p>
              The statements on this website have not been evaluated by the Food and Drug Administration.<br/>
              This product is not intended to diagnose, treat, cure or prevent any disease.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js